import React from 'react';
import DynamicIntakeForm from './DynamicIntakeForm'; // Adjust layout path as needed

const params = new URLSearchParams(window.location.search);

const IntakeForm = () => {
  return <DynamicIntakeForm formtype={params.get('formtype') || 'normalform'}
  _adminuserid={window.APPSETTING?.adminuserid || params.get('adminuserid') } 
  _userid={window.APPUSER?.user?.userid || params.get('userid') }

  />;
};

export default IntakeForm;